var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar',{on:{"openModal":_vm.openModal}}),_c('main',{staticClass:"container-fluid d-flex pt-3 flex-column min-vh-100"},[_c('RouterView'),_c('Footer',{on:{"openModal":_vm.openModal}}),_c('ContactModal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }